import React from "react";
import { Button, Col, Modal, Row, Spin, Typography } from "antd";
import { logOut } from "../store/auth/auth.action";
import { useDispatch } from "react-redux";
const { Text } = Typography;
export const Loading = () => {
  return (
    <div className="loading">
      <Spin />
    </div>
  );
};

export const LoadingScreen = () => {
  return (
    <div className="screen loading">
      <Spin />
    </div>
  );
};

export const RejectScreen = () => {
  const dispatch = useDispatch();
  return (
    <Modal open={true} footer={false} width={400}>
      <Row gutter={[20, 20]}>
        <Col span={24} align="center">
          <Text type="danger">
            You are not an owner. <br /> You cannot access the Admin Portal.
          </Text>
        </Col>
        <Col span={24} align="center">
          <Button type="default" onClick={() => dispatch(logOut())}>
            Logout
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};
